module.exports = __webpack_public_path__ + "static/media/shimla.e953f763.jpg";